import { render, staticRenderFns } from "./search-other-boat-types.vue?vue&type=template&id=191f05ed&scoped=true"
import script from "./search-other-boat-types.vue?vue&type=script&lang=js"
export * from "./search-other-boat-types.vue?vue&type=script&lang=js"
import style0 from "./search-other-boat-types.vue?vue&type=style&index=0&id=191f05ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191f05ed",
  null
  
)

export default component.exports